import { Stack, Tab, Tabs, Typography } from '@mui/material';
import { useState } from 'react';
import FixturesTab from './FixturesTab';
import IntakeSummariesTab from './IntakeSummariesTab';
import RolesPermissionsTab from './RolesPermissionsTab';

const TABS = [
    { label: 'Fixtures', Component: FixturesTab },
    { label: 'Intake Summaries', Component: IntakeSummariesTab },
    { label: 'Roles & Permissions', Component: RolesPermissionsTab },
];

export default function LexoAdmin() {
    const [tabIndex, setTabIndex] = useState(0);
    const { Component } = TABS[tabIndex];

    return (
        <Stack spacing={3}>
            <Typography variant="h1">Lexo Admin</Typography>
            <Tabs
                value={tabIndex}
                onChange={(_, value: number) => setTabIndex(value)}
                sx={{ borderBottom: '1px solid', borderColor: 'neutral.borderColor' }}
            >
                {TABS.map(({ label }) => (
                    <Tab key={label} label={label} sx={{ textTransform: 'none' }} />
                ))}
            </Tabs>
            <Component />
        </Stack>
    );
}
